// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","InstagramEmbed":"baz_a","InstagramEmbed__mask":"baz_b bht_bi bht_bo bht_wz"};